module.exports = __webpack_public_path__ + "static/visionar_augemented_reality_AR-contact-lenses-addcdbc661eecd9eb995122829404908.jpg";